type OfflineQueuedMeta = { offlineQueued?: boolean }

/** True when Redux middleware queued the action instead of hitting the API. */
export function isOfflineQueuedAction(result: unknown): boolean {
  if (!result || typeof result !== 'object' || !('meta' in result)) {
    return false
  }

  return Boolean((result as { meta?: OfflineQueuedMeta }).meta?.offlineQueued)
}

/** True for fulfilled reducer actions injected by offlineMiddleware. */
export function isOfflineQueuedFulfilledAction(action: unknown): boolean {
  if (!action || typeof action !== 'object' || !('meta' in action)) {
    return false
  }

  return Boolean((action as { meta?: OfflineQueuedMeta }).meta?.offlineQueued)
}

export function isOfflineOptimisticPayload(payload: unknown): boolean {
  if (!payload || typeof payload !== 'object') {
    return false
  }

  return Boolean((payload as { _offlineOptimistic?: boolean })._offlineOptimistic)
}
